"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDataService = void 0;
const api_1 = require("../api");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
class FileDataService {
    constructor({ client }) {
        this.apiVersion = api_1.apiVersion;
        this.client = client;
    }
    fileUpload(params) {
        const formData = new FormData();
        formData.append("file", params.body.file);
        formData.append("type", new Blob([JSON.stringify(params.body.type)], {
            type: constants_1.applicationJsonType,
        }));
        formData.append("request", new Blob([params.body.request], {
            type: constants_1.applicationJsonType,
        }));
        return this.client
            .fetch(`/${this.apiVersion}/files`, {
            method: "POST",
            headers: {
                [constants_1.authorizationHeader]: (0, utils_1.bearerToken)(params.fileUploadToken),
            },
            body: formData,
        })
            .then((response) => response.json());
    }
}
exports.FileDataService = FileDataService;
